export default __webpack_public_path__ + "static/media/estado-18.72140e02.svg";